module.exports = __webpack_public_path__ + "static/media/ios-barcode.29f38fb6.svg";